<template>
<div class="basic-breadcrumb-area gray-bg ptb-70">
  <div class="container relative-container">
    <div v-if="leftButton" class="breadcrumbs-floating-actions">
      <a
        :href="leftButton.link"
        class="btn btn-primary"
        target="_blank">{{leftButton.text}}</a> <br />
        <a href="mailto:hello@fredericka.me" > hello@fredericka.me </a>
    </div>
    <div class="basic-breadcrumb text-center">
      <h3 class="">{{title}}</h3>
      <h6 v-if="subTitle" class="">{{subTitle}}</h6>
      <ol class="breadcrumb text-xs">
        <li v-for="(link, text, index) in breadCrumbs" v-bind:key="index">
          <router-link :to="link">{{text}}</router-link>
        </li>
        <li class="active">{{lastCrumb}}</li>
      </ol>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    title: String,
    subTitle: String,
    breadCrumbs: {
      type: Object,
      default: () => { 
        return {
          Home: "/"
        }
      }
    },
    lastCrumb: String,
    leftButton: Object
  }
}
</script>
<style lang="scss" scoped>
.relative-container { 
  position: relative;
}
.breadcrumbs-floating-actions { 
  position: absolute;
  a {
    margin-bottom: 10px;
  }
  .btn:hover {
    background: #ffffff;
    color: #333;
  } 
}
@media only screen and (max-width: 768px) {
  .breadcrumbs-floating-actions {
    left: calc(50% - 70px);
    top: 100px;
  }
}
</style>